import { mq, Text } from '@wistia/vhs';
import styled, { css } from 'styled-components';

export const MediaLayout = styled.div<{
  $tabsShouldBeInRightColumn: boolean;
}>`
  align-items: start;
  column-gap: ${({ theme }) => theme.spacing.space06};
  display: grid;
  grid-area: main;
  grid-template-areas:
    'Frontmatter'
    'PlayerOrEquivalent'
    'TabbedArea';
  grid-template-columns: minmax(0, auto);
  padding: 0 ${({ theme }) => theme.spacing.space05};
  position: relative;
  row-gap: ${({ theme }) => theme.spacing.space05};
  --wistia-background-color: var(--wui-color-bg-app);

  ${({ $tabsShouldBeInRightColumn }) =>
    $tabsShouldBeInRightColumn
      ? css`
          grid-template-areas:
            'Frontmatter TabbedArea'
            'PlayerOrEquivalent TabbedArea'
            'ContentUnderPlayerWhenTabsAreInRightColumn TabbedArea';
          grid-template-columns: minmax(0, 1fr) minmax(300px, 0.5fr);
          grid-template-rows: auto auto minmax(0, 1fr);
          padding-right: 0;

          /* The 112 px here is 80px (the height of the top bar) + 16px * 2 (the padding of the LayoutContainer) */
          height: calc(100vh - 112px);
        `
      : ''}

  ${mq.smAndDown} {
    padding: 0;
  }
`;

export const LoadingStatesMediaPlaceholder = styled.div`
  align-items: center;
  background-color: #dedee1;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const MediaPlaceholder = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.grey800};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const PlaceholderText = styled(Text)`
  font-family: Helvetica, Arial, sans-serif;
  font-size: 30px;
`;

export const PlayerOrEquivalent = styled.div`
  grid-area: PlayerOrEquivalent;
  z-index: 1;
`;

export const PlayerOrPlaceholderContainer = styled.div<{ aspectRatio: number }>`
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  max-height: 60vh;
  margin: 0 auto;
`;

export const PlayerAndTimelineContainer = styled.div``;

export const TabbedArea = styled.div<{ $isInRightColumn: boolean }>`
  background-color: ${({ $isInRightColumn }) => ($isInRightColumn ? 'white' : '')};
  border-radius: ${({ theme, $isInRightColumn }) =>
    $isInRightColumn ? theme.spacing.space04 : ''};
  box-shadow: ${({ theme, $isInRightColumn }) => ($isInRightColumn ? theme.shadow.elevation2 : '')};
  display: grid;
  grid-area: TabbedArea;
  grid-template-rows: auto minmax(0, 1fr);
  height: ${({ $isInRightColumn }) => ($isInRightColumn ? '100%' : '')};
  margin-bottom: 20px;
  overflow: ${({ $isInRightColumn }) => ($isInRightColumn ? 'hidden' : '')};
  padding: ${({ theme, $isInRightColumn }) => ($isInRightColumn ? theme.spacing.space04 : 0)}
    ${({ theme, $isInRightColumn }) =>
      $isInRightColumn ? theme.spacing.space04 : theme.spacing.space05};
  position: relative;
  z-index: 0;
`;

export const StickyTabBarWrapper = styled.div`
  background-color: var(--wistia-background-color);
  padding-top: ${({ theme }) => theme.spacing.space03};
  position: sticky;
  z-index: 1;
`;

// Typical height of the `StickyTabBarWrapper` - used to calculate top offset for other
// sticky elements / update if this element's children are updated such that the height changes
export const STICKY_TAB_BAR_WRAPPER_HEIGHT = 46;

export const ContainerForContentUnderPlayerWhenTabsAreInRightColumn = styled.div`
  grid-area: ContentUnderPlayerWhenTabsAreInRightColumn;
  padding-bottom: ${({ theme }) => theme.spacing.space04};
`;

export const PlayerContainer = styled.div<{ $isPictureInPicture: boolean }>`
  box-shadow: ${({ $isPictureInPicture, theme }) =>
    $isPictureInPicture ? theme.shadow.elevation2 : ''};
`;

export const SideCarTopBar = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing.space04};
  grid-template-columns: 1fr auto;
`;
